// frontend/src/components/gastos/PanelGastos.jsx
import React, { useState, useEffect, useCallback } from 'react';

const API = process.env.REACT_APP_API_URL || 'https://api.lamilara.com/api';
function getToken() { return localStorage.getItem('calleb_token'); }
function authHeaders() { const t=getToken(); return t?{Authorization:`Bearer ${t}`}:{}; }

const CATEGORIAS = ['Mantenimiento','Vigilancia','Jardinería','Electricidad',
                    'Agua','Limpieza','Administración','Reparaciones','Seguros','Internet','Servicios','Otro'];

function fmt(val) { return `$${parseFloat(val||0).toFixed(2)}`; }
function formatFecha(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString('es-VE',{ day:'2-digit',month:'short',year:'numeric' });
}

// ── Modal editar/crear gasto ──────────────────────────────
function ModalGasto({ gasto, onClose, onGuardado }) {
  const esNuevo = !gasto;
  const [form, setForm] = useState({
    fecha_gasto:  gasto?.fecha_gasto?.slice(0,10) || new Date().toISOString().slice(0,10),
    categoria:    gasto?.categoria || 'Mantenimiento',
    descripcion:  gasto?.descripcion || '',
    monto:        gasto?.monto || '',
    proveedor:    gasto?.proveedor || '',
    factura_ref:  gasto?.factura_ref || '',
  });
  const [guardando, setGuardando] = useState(false);
  const [error,     setError]     = useState(null);
  const set = (k,v) => setForm(f=>({...f,[k]:v}));

  const handleGuardar = async () => {
    if (!form.descripcion||!form.monto){ setError('Descripción y monto son obligatorios'); return; }
    setGuardando(true); setError(null);
    try {
      const url    = esNuevo ? `${API}/gastos` : `${API}/gastos/${gasto.id}`;
      const method = esNuevo ? 'POST' : 'PUT';
      const res = await fetch(url, {
        method, headers:{'Content-Type':'application/json',...authHeaders()},
        body: JSON.stringify({
          ...form, monto:parseFloat(form.monto),
          anio_fiscal:parseInt(form.fecha_gasto.slice(0,4)),
        }),
      });
      const data = await res.json();
      if (!data.ok) throw new Error(data.mensaje);
      onGuardado();
    } catch(e){ setError(e.message); }
    finally{ setGuardando(false); }
  };

  const handleEliminar = async () => {
    if (!window.confirm(`¿Eliminar este gasto?\n"${gasto.descripcion}"\nEsta acción no se puede deshacer.`)) return;
    setGuardando(true);
    try {
      const res = await fetch(`${API}/gastos/${gasto.id}`,
        { method:'DELETE', headers:authHeaders() });
      const data = await res.json();
      if (!data.ok) throw new Error(data.mensaje);
      onGuardado();
    } catch(e){ setError(e.message); }
    finally{ setGuardando(false); }
  };

  return (
    <div onClick={onClose} style={{ position:'fixed',inset:0,background:'rgba(0,0,0,.45)',
        display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000,padding:16 }}>
      <div onClick={e=>e.stopPropagation()} style={{ background:'#fff',borderRadius:16,
          padding:28,width:'100%',maxWidth:460,boxShadow:'0 20px 60px rgba(0,0,0,.25)' }}>
        <h3 style={{ fontSize:16,fontWeight:700,color:'#1a3a5c',marginBottom:20 }}>
          {esNuevo ? '+ Nuevo Gasto' : '✏️ Editar Gasto'}
        </h3>
        {error && <div style={{ padding:'10px',background:'#fef2f2',color:'#dc2626',
                                borderRadius:8,marginBottom:14,fontSize:13 }}>⚠️ {error}</div>}
        <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr',gap:12 }}>
          <div>
            <label style={lbl}>Fecha*</label>
            <input type="date" value={form.fecha_gasto}
                   onChange={e=>set('fecha_gasto',e.target.value)} style={inp}/>
          </div>
          <div>
            <label style={lbl}>Monto (USD)*</label>
            <input type="number" step="0.01" value={form.monto}
                   onChange={e=>set('monto',e.target.value)} style={inp} placeholder="0.00"/>
          </div>
          <div>
            <label style={lbl}>Categoría*</label>
            <select value={form.categoria} onChange={e=>set('categoria',e.target.value)} style={inp}>
              {CATEGORIAS.map(c=><option key={c} value={c}>{c}</option>)}
            </select>
          </div>
          <div>
            <label style={lbl}>Proveedor</label>
            <input type="text" value={form.proveedor}
                   onChange={e=>set('proveedor',e.target.value)} style={inp}/>
          </div>
          <div style={{ gridColumn:'1/-1' }}>
            <label style={lbl}>Descripción*</label>
            <input type="text" value={form.descripcion}
                   onChange={e=>set('descripcion',e.target.value)} style={inp}/>
          </div>
          <div style={{ gridColumn:'1/-1' }}>
            <label style={lbl}>N° Factura / Referencia</label>
            <input type="text" value={form.factura_ref}
                   onChange={e=>set('factura_ref',e.target.value)} style={inp}/>
          </div>
        </div>
        <div style={{ display:'flex',gap:8,marginTop:20 }}>
          {!esNuevo && (
            <button onClick={handleEliminar} disabled={guardando}
                    style={{ ...btn,background:'#fef2f2',color:'#dc2626',flex:1 }}>
              🗑 Eliminar
            </button>
          )}
          <button onClick={onClose}
                  style={{ ...btn,background:'#f3f4f6',color:'#374151',flex:1 }}>
            Cancelar
          </button>
          <button onClick={handleGuardar} disabled={guardando}
                  style={{ ...btn,background:'#1a3a5c',color:'#fff',flex:2 }}>
            {guardando?'Guardando…':'💾 Guardar'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default function PanelGastos() {
  const anioActual = new Date().getFullYear();
  const [gastos,   setGastos]   = useState([]);
  const [total,    setTotal]    = useState(0);
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState(null);
  const [anio,     setAnio]     = useState(anioActual);
  const [modal,    setModal]    = useState(null); // null | 'nuevo' | gasto_objeto

  const anios = [anioActual, anioActual-1, anioActual-2];

  const cargar = useCallback(async () => {
    setLoading(true); setError(null);
    try {
      const res  = await fetch(`${API}/gastos?anio=${anio}`, { headers:authHeaders() });
      const data = await res.json();
      if (!data.ok) throw new Error(data.mensaje);
      setGastos(data.gastos||[]);
      setTotal(data.total_monto||0);
    } catch(e){ setError(e.message); }
    finally{ setLoading(false); }
  }, [anio]);

  useEffect(()=>{ cargar(); },[cargar]);

  const porCategoria = gastos.reduce((acc,g)=>{
    acc[g.categoria]=(acc[g.categoria]||0)+parseFloat(g.monto); return acc;
  },{});

  return (
    <div style={{ padding:24 }}>
      <div style={{ display:'flex',justifyContent:'space-between',
                    alignItems:'flex-start',flexWrap:'wrap',gap:12,marginBottom:20 }}>
        <div>
          <h2 style={{ fontSize:20,fontWeight:700,color:'#1a3a5c',margin:0 }}>
            💸 Gastos del Condominio
          </h2>
          <p style={{ fontSize:12,color:'#6b7280',margin:'4px 0 0' }}>
            {gastos.length} registros · Total:{' '}
            <strong style={{ color:'#dc2626' }}>{fmt(total)}</strong>
          </p>
        </div>
        <div style={{ display:'flex',gap:10,alignItems:'center' }}>
          <select value={anio} onChange={e=>setAnio(parseInt(e.target.value))} style={inp}>
            {anios.map(a=><option key={a} value={a}>{a}</option>)}
          </select>
          <button onClick={()=>setModal('nuevo')}
                  style={{ ...btn,background:'#1a3a5c',color:'#fff',padding:'9px 16px' }}>
            + Nuevo Gasto
          </button>
        </div>
      </div>

      {/* Resumen por categoría */}
      {Object.keys(porCategoria).length>0 && (
        <div style={{ display:'flex',gap:10,flexWrap:'wrap',marginBottom:20 }}>
          {Object.entries(porCategoria).sort(([,a],[,b])=>b-a).map(([cat,monto])=>(
            <div key={cat} style={{ background:'#fff',borderRadius:8,padding:'10px 16px',
                                    boxShadow:'0 1px 3px rgba(0,0,0,.07)',fontSize:12 }}>
              <div style={{ color:'#6b7280',marginBottom:2 }}>{cat}</div>
              <div style={{ fontWeight:700,color:'#dc2626' }}>{fmt(monto)}</div>
            </div>
          ))}
        </div>
      )}

      {error && <div style={{ padding:12,background:'#fef2f2',color:'#dc2626',
                              borderRadius:8,marginBottom:16,fontSize:13 }}>⚠️ {error}</div>}

      <div style={{ background:'#fff',borderRadius:12,
                    boxShadow:'0 1px 4px rgba(0,0,0,.08)',overflowX:'auto' }}>
        <table style={{ width:'100%',borderCollapse:'collapse',minWidth:600 }}>
          <thead>
            <tr style={{ background:'#f8fafc' }}>
              {['Fecha','Categoría','Descripción','Proveedor','Monto',''].map(h=>(
                <th key={h} style={{ padding:'10px 12px',textAlign:'left',fontSize:11,
                                     fontWeight:600,color:'#6b7280',
                                     borderBottom:'2px solid #e5e7eb' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading?(
              <tr><td colSpan={6} style={{ padding:40,textAlign:'center',color:'#9ca3af' }}>
                Cargando…</td></tr>
            ):gastos.length===0?(
              <tr><td colSpan={6} style={{ padding:40,textAlign:'center',color:'#9ca3af' }}>
                No hay gastos para {anio}.</td></tr>
            ):gastos.map(g=>(
              <tr key={g.id} style={{ borderBottom:'1px solid #f3f4f6' }}>
                <td style={td}>{formatFecha(g.fecha_gasto)}</td>
                <td style={td}>
                  <span style={{ background:'#eff6ff',color:'#1d4ed8',
                                 padding:'2px 8px',borderRadius:12,fontSize:11 }}>
                    {g.categoria}
                  </span>
                </td>
                <td style={td}>{g.descripcion}</td>
                <td style={{ ...td,color:'#6b7280' }}>{g.proveedor||'—'}</td>
                <td style={{ ...td,fontWeight:700,color:'#dc2626' }}>{fmt(g.monto)}</td>
                <td style={td}>
                  <button onClick={()=>setModal(g)}
                          style={{ ...btn,background:'#f3f4f6',color:'#374151',
                                   padding:'4px 10px',fontSize:11 }}>
                    ✏️ Editar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
          {gastos.length>0 && (
            <tfoot>
              <tr style={{ background:'#f8fafc',borderTop:'2px solid #e5e7eb' }}>
                <td colSpan={4} style={{ padding:'10px 12px',fontWeight:700,
                                         fontSize:13,color:'#374151' }}>Total {anio}</td>
                <td colSpan={2} style={{ padding:'10px 12px',fontWeight:700,
                                         color:'#dc2626',fontSize:14 }}>{fmt(total)}</td>
              </tr>
            </tfoot>
          )}
        </table>
      </div>

      {modal && (
        <ModalGasto
          gasto={modal==='nuevo'?null:modal}
          onClose={()=>setModal(null)}
          onGuardado={()=>{ setModal(null); cargar(); }}
        />
      )}
    </div>
  );
}

const inp = { padding:'8px 12px',borderRadius:8,border:'1px solid #d1d5db',
              fontSize:13,background:'#fff',color:'#374151',width:'100%',boxSizing:'border-box' };
const lbl = { display:'block',fontSize:11,fontWeight:600,color:'#374151',marginBottom:4 };
const btn = { border:'none',borderRadius:8,padding:'8px 14px',fontSize:12,cursor:'pointer',fontWeight:600 };
const td  = { padding:'10px 12px',verticalAlign:'middle',fontSize:13 };
